export default {
  start: ({commit, state}, value) => {
    return new Promise((resolve, reject) => {
      commit('setActive', true)
    })
  },
  end: ({ commit, state }, value) => {
    return new Promise((resolve, reject) => {
      commit('setComplete', true)

      setTimeout(() => {
        commit('setActive', false)
      }, 1200)
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/splash/actions.js